module.exports = __webpack_public_path__ + "img/delivery-img.2f79cddf.png";